import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Image as ImageIcon, Video } from 'lucide-react';
import { useMosque } from '../contexts/MosqueContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const WartaPage = () => {
  const { mosqueId } = useMosque();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, [mosqueId]);

  const fetchEvents = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/events`, { params: { mosque_id: mosqueId } });
      setEvents(data);
    } catch (error) {
      console.error('Error fetching events:', error);
      setEvents([
        {
          id: '1',
          title: 'Kajian Rutin Malam Jumat',
          description: 'Kajian tafsir Al-Quran bersama Ustadz Muhammad Arifin. Tema: Hikmah di Balik Ujian.',
          date: '2024-02-09',
          image_url: 'https://images.pexels.com/photos/6209699/pexels-photo-6209699.jpeg',
          video_url: null
        },
        {
          id: '2',
          title: 'Santunan Anak Yatim',
          description: 'Kegiatan santunan bulanan untuk 50 anak yatim di lingkungan masjid.',
          date: '2024-02-05',
          image_url: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c',
          video_url: null
        },
        {
          id: '3',
          title: 'Khataman Al-Quran 30 Juz',
          description: 'Alhamdulillah 12 santri telah menyelesaikan hafalan 30 juz Al-Quran.',
          date: '2024-01-28',
          image_url: 'https://images.pexels.com/photos/4195325/pexels-photo-4195325.jpeg',
          video_url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ'
        },
        {
          id: '4',
          title: 'Bakti Sosial Ramadhan',
          description: 'Program pembagian 500 paket sembako untuk masyarakat kurang mampu.',
          date: '2024-01-20',
          image_url: 'https://images.pexels.com/photos/6995303/pexels-photo-6995303.jpeg',
          video_url: null
        }
      ]);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-[#F8F9FA] px-6 py-8 pb-24"
    >
      <div className="mb-8">
        <h1 className="text-4xl font-heading font-bold tracking-tight text-primary-dark mb-2">
          Warta & Program
        </h1>
        <p className="text-sm font-body text-text-secondary">
          Kegiatan dan berita masjid
        </p>
      </div>

      <div className="space-y-6">
        {events.map((event, index) => (
          <motion.div
            key={event.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 * index }}
            className="bg-white rounded-3xl shadow-sm border border-stone-100 overflow-hidden"
            data-testid={`event-card-${event.id}`}
          >
            {event.image_url && (
              <div
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `url('${event.image_url}')` }}
              />
            )}
            <div className="p-5">
              <div className="flex items-center gap-2 mb-3">
                <Calendar className="w-4 h-4 text-emerald-600" />
                <span className="text-xs font-body text-text-secondary">
                  {formatDate(event.date)}
                </span>
              </div>
              <h3 className="text-xl font-body font-semibold text-text-primary mb-2">
                {event.title}
              </h3>
              <p className="text-sm font-body text-text-secondary leading-relaxed mb-4">
                {event.description}
              </p>
              {event.video_url && (
                <a
                  href={event.video_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-body font-medium text-emerald-700 hover:text-emerald-800"
                >
                  <Video className="w-4 h-4" />
                  Tonton Video
                </a>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default WartaPage;